import { Fragment } from 'react';
import InfoCard from '../molecules/InfoCard';
import axios from 'axios';
import { useState, useEffect } from 'react';
import config from '../../config';
import { Skeleton } from '@mui/material';
import { useQuery } from 'react-query';

const InfoCardStudentSpread = () => {
  const [studentSpread, setStudentSpread] = useState();

  useQuery('getInfoCard', async () => {
    const getData = new FormData();
    getData.append('mode', 'getStudentSpread');
    getData.append('auth', localStorage.getItem('token'));

    await axios.post(config.STUDENTS_API, getData).then(output => {
      setStudentSpread(output?.data?.response?.studentSpread);
    });
  });

  let totalStudents = 0;

  return (
    <InfoCard cardTitle='Student Distribution'>
      {studentSpread ? (
        <div className=' grid grid-cols-2 gap-2'>
          {studentSpread?.map((spread, index) => {
            totalStudents += Number(spread.count);
            return (
              <Fragment key={index}>
                <div>Level {spread.level}</div>
                <div>{spread.count}</div>
              </Fragment>
            );
          })}
        </div>
      ) : (
        <div>
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
          <Skeleton variant='text' />
        </div>
      )}

      <div className='mt-4'>
        <span className='font-bold'>Total:</span> {totalStudents}
      </div>
    </InfoCard>
  );
};

export default InfoCardStudentSpread;
